<template>
  <div class="article-card" @click="$emit('click')">
    <h3>{{ article.title }}</h3>
    <p>{{ article.content }}</p>
  </div>
</template>

<script>
export default {
  name: 'ArticleCardComponent',
  props: {
    article: {
      type: Object,
      required: true
    }
  }
}
</script>